var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainPetChew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_3360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9775 11.36C21.2238 8.16514 22.3577 4.55799 24.9342 3.47583C26.3599 4.69539 29.201 7.39216 29.1598 8.42276C29.1083 9.71102 23.9552 12.3391 22.5639 12.8028C21.1726 13.2666 17.514 17.389 15.6589 18.5227C14.1748 19.4296 10.8494 23.9849 9.37218 26.1492H7.10485L3.96143 22.0783C4.71718 21.4943 6.63063 20.2026 8.23837 19.7079C10.2481 19.0895 14.7312 14.5549 17.9775 11.36Z",
    fill: "#F3EAD9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56794 18.9476C6.36283 18.6947 5.85696 18.0443 7.4105 18.2611C8.92396 18.6782 7.98875 20.7541 8.31392 21.6935C8.57406 22.445 9.43396 23.9335 9.83139 24.5839L5.56794 26.4626C4.89351 25.8003 3.3062 24.1648 2.35236 22.9219C1.16007 21.3683 1.41295 20.9347 1.77425 20.0315C2.13555 19.1282 4.77306 19.2005 5.56794 18.9476Z",
    fill: "#FEF7E5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12418 23.0664C1.44943 22.1271 4.62873 21.6573 6.50759 21.8019C8.18156 21.8019 11.6234 22.0548 11.9992 23.0664C12.4689 24.331 10.1566 25.8846 9.39783 26.4988C8.63909 27.113 9.47009 27.5104 8.85587 28.4498C8.24166 29.3892 6.2545 29.0279 4.84543 28.8472C3.43635 28.6666 3.50861 28.3053 3.14731 28.0885C2.78601 27.8717 2.17188 25.3426 1.88284 24.6561C1.59379 23.9697 0.798932 24.0058 1.12418 23.0664Z",
    fill: "#F3EAD9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13686 28.183C2.89115 27.46 3.61601 27.1938 4.00915 27.151C5.37288 26.7456 6.66288 27.5565 7.4246 27.9005C8.18632 28.2445 8.88661 28.183 8.94804 28.4656C9.00947 28.7482 8.14243 29.0868 6.95774 29.3133C5.77306 29.5398 3.44401 29.0868 3.13686 28.183Z",
    fill: "#FEF8E6",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4894 8.54992C22.4894 7.65123 22.1263 6.85917 21.9448 6.57548L25.4851 5.5542L27.6297 8.10735L26.5064 11.5796C26.4042 11.8974 25.9753 12.703 25.0766 13.3839C23.9532 14.2349 22.4894 9.67329 22.4894 8.54992Z",
    fill: "#F3EAD9",
    stroke: "black",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7702 10.5584C24.7156 9.63245 23.5901 7.24494 23.0342 6.16692C23.749 5.71303 25.4443 4.68269 26.5064 4.19249C27.834 3.57973 28.7872 5.92863 30.0808 6.54139C31.3744 7.15414 31.1361 8.48178 31.034 8.89029C30.9318 9.29879 30.5233 9.60517 29.2978 10.0137C28.0723 10.4222 26.6085 12.8392 26.166 13.0775C25.7234 13.3158 24.8383 11.7158 24.7702 10.5584Z",
    fill: "#F3EAD9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2285 2.65518C21.4653 2.1391 22.4652 0.851636 24.4749 0.697068C25.5543 0.509051 27.1545 0.697068 28.2366 1.41847C29.3188 2.13987 30.7616 5.43783 30.2978 5.85007C29.8341 6.26232 25.4025 4.92253 24.1657 5.12865C22.929 5.33477 22.053 7.49904 20.7132 8.01434C19.3734 8.52965 20.9916 3.17126 21.2285 2.65518Z",
    fill: "#FEF7E5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5574 7.66484C23.1703 7.15422 24.4638 6.71162 25.4511 6.71162C26.4383 6.71162 29.1276 7.39247 30.251 7.12017C31.3744 6.84788 30.251 6.09885 29.9787 5.14572C29.7063 4.19258 26.5064 3.03509 24.8723 3.17126C23.2383 3.30743 22.1149 4.26062 21.2298 5.14572C20.3447 6.03081 20.1744 8.89034 20.6169 9.16268C21.0595 9.43501 21.9446 8.17546 22.5574 7.66484Z",
    fill: "#F3EAD9",
    stroke: "black",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_3360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    fill: "white",
    transform: "translate(0.0834961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainPetChew);
export default __webpack_public_path__ + "static/media/icon-main-pet-chew.056af6a22876bc11b746c5106455dd65.svg";
export { ForwardRef as ReactComponent };